<template>
  <div class="home">
    <header-div class="header-box"></header-div>
    <div class="content-box">

      <left-div class="leftAside"></left-div>

      <div class="right-content">
        <router-view/>
      </div>
    </div>
      <div class="footer-text">Copyright 益魔方   <a style="color: #fff" href="https://beian.miit.gov.cn/" target="_blank">京ICP备15038897号-3</a>
          <a data-v-23f1b31c="" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802038214" target="_blank" class="margin-lr-xs" style="color: rgb(255, 255, 255);"><img data-v-23f1b31c="" data-v-45865956="" src="http://www.beian.gov.cn/img/new/gongan.png" alt="">公安备案号：11010802038214</a>
          北京易魔方科技集团有限公司 版权所有
      </div>
  </div>
</template>

<script>

  import headerDiv from './components/header'
  import leftDiv from './components/leftAside'

  export default {
    name: 'home',
    components: {
      headerDiv,
      leftDiv

    }
  }
</script>


<style scoped lang="scss">
  .header-box{
    width: 100%;
    height: 100px;
    background: #0a2240;
  }
  .content-box {
    /*display: flex;*/
    /*align-items: flex-start;*/
    /*justify-content: space-between;*/
    position: absolute;
    top: 100px;
    left: 0;
    right: 0;
    bottom: 0;
    padding-bottom: 40px;

    .leftAside {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 300px;
      height: 100%;
      background-color: #122d4e;
      box-shadow: 0px 6px 16px 1px
      rgba(10, 34, 64, 0.47);
      /*overflow-x: unset;*/
      overflow-y: scroll;
    }

    .leftAside::-webkit-scrollbar {
      display: none;
    }

    .right-content {
      position: absolute;
      top: 0;
      left: 300px;
      right: 0;
      bottom: 40px;
      overflow-y: scroll;

    }
  }
  .footer-text{
    position: fixed;
    left: 300px;
    bottom: 0;
    right: 0;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    background: #0a2240;
    z-index: 99;
  }
</style>
